import React from 'react';
import FlexBox from "./FlexBox";
import {Button} from "react-bootstrap";
import './ConfirmModal.css';

const ConfirmModal = ({show, setShow, title, body, callback, fallback=()=>setShow(false), no="No", yes="Yes", variant="primary", mobileIcon=null}) => {
    return (
        <FlexBox hidden={!show} className="confirm-modal-backdrop" style={{background:"rgba(0,0,0,.3)",width:"100vw", height:"100vh", position:"fixed", top:0, left:0, zIndex:12}}>
            <FlexBox direction={"column"} style={{textAlign:"center",width:"450px", height:"max-content", background:"white", border:"1px solid #ebebeb", padding:"25px"}} className={"hard-shadow confirm-modal-content"}>
                {mobileIcon && <img src={mobileIcon} alt="icon" className="confirm-modal-icon" />}
                <h3 className="confirm-modal-title">{title}</h3>
                <p className="confirm-modal-body">{body}</p>
                <FlexBox direction={"row-reverse"} style={{width:"max-content"}} justify={"space-between"} className="confirm-modal-buttons">
                    <Button  variant={"secondary"} style={{width:"100px"}} onClick={fallback} className="confirm-modal-cancel">{no}</Button>
                    &nbsp;&nbsp;
                    <Button variant={variant} style={{width:"100px"}} onClick={callback} className="confirm-modal-confirm">{yes}</Button>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )
};

export default ConfirmModal;